// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"464":"61337c0f","575":"7eafed71"}[chunkId] + ".chunk.css";
};